import { Fragment } from 'react';
import { Text } from '../../FormControls/Text';
import { Box } from '../../FormControls/Box';
import { Stack } from '../../FormControls/Stack';
import { CurrencyExchange, ArrowForwardIos, AccountBalanceWallet } from '@mui/icons-material';

import { ScreenControl } from '../ScreenControl';
import { useDispatch } from 'react-redux';
import { setPaymentType } from '../../../../main/slices/bussinessSlice';

export const PaymentSelector = () => {

    const dispatch = useDispatch();

    const handleSelect = (type) => {
        dispatch(setPaymentType(type));
        return true;
    }

    return (
        <Fragment>

            <Stack flex={{ flexDirection: "column" }}>
                <Text classes={["subtitle"]}> ¿Cómo deseas cobrar? </Text>
                <Text classes={["title"]}> Selecciona tu forma de cobrar </Text>
            </Stack>

            <Stack flex={{ flexDirection: "column" }}>

                {/* FIAT PAYMENT */}
                <ScreenControl index={{ fw: 9 }} disabled={false} parentClasses={["cardOption", "marginTB1em"]} beforeSubmit={() => handleSelect("FIAT")}>
                    <Stack flex={{ flexDirection: "row", alignItems: "center" }}>
                        <Box superStyle={{ width: "20%" }}>
                            <Text classes={["left"]}>
                                <CurrencyExchange></CurrencyExchange>
                            </Text>
                        </Box>
                        <Box>
                            <Text classes={["mediumText"]}>Banco en dólares o quetzales</Text>
                            <Text classes={["annotation"]}>Agregar cuenta de banco</Text>
                        </Box>
                        <Box superStyle={{ width: "20%" }}>
                            <Text classes={["right"]}>
                                <ArrowForwardIos></ArrowForwardIos>
                            </Text>
                        </Box>
                    </Stack>
                </ScreenControl>

                {/* CRYPTO PAYMENT */}
                <ScreenControl index={{ fw: 11 }} disabled={false} parentClasses={["cardOption", "marginTB1em"]} beforeSubmit={() => handleSelect("CRYPTO")}>
                    <Stack flex={{ flexDirection: "row", alignItems: "center" }}>
                        <Box superStyle={{ width: "20%" }}>
                            <Text classes={["left"]}>
                                <AccountBalanceWallet></AccountBalanceWallet>
                            </Text>
                        </Box>
                        <Box>
                            <Text classes={["mediumText"]}>Crypto</Text>
                            <Text classes={["annotation"]}>Agregar wallet</Text>
                        </Box>
                        <Box superStyle={{ width: "20%" }}>
                            <Text classes={["right"]}>
                                <ArrowForwardIos></ArrowForwardIos>
                            </Text>
                        </Box>
                    </Stack>
                </ScreenControl>

            </Stack>

            <ScreenControl disabled={true}></ScreenControl>
        </Fragment>
    );
}

